import React from "react";
import NavigationMenuEUWeb from "../../../components/src/NavigationMenuEU.web";
import { EverybrandIcon, HeartSmallIcon, HomeIcon, imageVector, redHeart, sendMedssageIcon, uploadIcon } from "./assets";
import { Box, Button, TextField, Typography, IconButton, Popover, Snackbar, Divider, styled, withStyles, MenuItem, Modal, CircularProgress } from "@material-ui/core";
import SuggestedBrands from "../../../components/src/SuggestedBrands";
import LikeButton from "../../../components/src/LikeButton";
import EuDashboardController from "./EuDashboardController.web";
import ProfileIcon from "../../../components/src/ProfileIcon";
import PostInfo from "../../../components/src/PostInfo";
import MoreHorizRoundedIcon from '@material-ui/icons/MoreHorizRounded';
import SettingsButton from "../../../components/src/SettingsButton";
import CustomLoader from "../../../components/src/CustomLoader.web"

import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import Poll from "./Poll.web";
import MobileNavEndUser from "./MobileNavEndUser.web";
import TopActiveUsersEU from "./TopActiveUsersEu.web";
import CommentButton from "../../../components/src/CommentButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import VolumeOffRoundedIcon from "@material-ui/icons/VolumeOffRounded";
import VolumeUpRoundedIcon from "@material-ui/icons/VolumeUpRounded";
import PhoneInput from "react-phone-input-2";
import { CommentOnboardingModal } from "./CommentOnboarding";
import { IconAvtar } from "../../contactlist/src/assets";

if (typeof document !== "undefined" && !document.getElementById("sound-flash-style")) {
  const s = document.createElement("style");
  s.id = "sound-flash-style";
  s.textContent = `
    @keyframes soundFlashFade { 0% { opacity: 1; transform: scale(1); } 100% { opacity: 0; transform: scale(1.1); } }
    video::-webkit-media-controls-start-playback-button,
    video::-webkit-media-controls-overlay-play-button,
    video::-webkit-media-controls-play-button,
    video::-webkit-media-controls-panel { display: none !important; opacity: 0 !important; }
  `;
  document.head.appendChild(s);
}

export default class EuDashboard extends EuDashboardController {
  isMobileViewport = () =>
    typeof window !== "undefined" && window.matchMedia("(max-width: 960px)").matches;

  async componentDidMount() {
    await super.componentDidMount();
    document.addEventListener("touchstart", this.unlockAudio, { once: true, passive: true });
  }

  async componentWillUnmount() {
    await super.componentWillUnmount();
    document.removeEventListener("touchstart", this.unlockAudio);
  }

  // On first touch (user gesture), unmute the current visible video so audio session is unlocked.
  // After this, IntersectionObserver can play subsequent videos with sound.
  unlockAudio = () => {
    const container = (this.homeRef as any)?.current as HTMLDivElement | null;
    if (!container) return;
    const idx = Math.round(container.scrollTop / container.clientHeight);
    const ref = (this.state.videoRefsHome as any)?.[idx];
    const video: HTMLVideoElement | null = ref?.current ?? null;
    if (!video) return;
    video.muted = false;
    video.volume = 1;
    video.play().catch(() => {
      video.muted = true;
      video.play().catch(() => { });
    });
  };

  private soundFlashTimer: ReturnType<typeof setTimeout> | null = null;

  showSoundFlash = (index: number) => {
    if (this.soundFlashTimer) clearTimeout(this.soundFlashTimer);
    this.setState({ soundFlashIndex: index });
    this.soundFlashTimer = setTimeout(() => {
      this.setState({ soundFlashIndex: -1 });
    }, 600);
  };

  toggleVideoSound = (index: number) => {
    const videoRef = this.state.videoRefsHome[index];
    const video = videoRef?.current;
    if (!video) return;

    const newMuted = !this.state.globalMuted;
    video.muted = newMuted;
    if (!newMuted) video.volume = 1;
    this.setState({ globalMuted: newMuted });
    this.showSoundFlash(index);
  };

  handleHardCloseCommentModal = () => {
    this.setState({ commentModalOpen: false });

    Object.values(this.state.videoRefsHome).forEach((ref: any) => {
      if (ref?.current) {
        ref.current.pause();
        ref.current.muted = true;   // 🔥 important
        ref.current.currentTime = 0;
      }
    });
  };


  handleFileRender(
    postFile: { link: string, gif_link?: string, link_content_type: string },
    index: number
  ) {

    const isVideo = postFile.link_content_type.includes("video");
    const isMobile = this.isMobileViewport();
    const isSoundEnabled = !this.state.globalMuted;
    const isFlashing = this.state.soundFlashIndex === index;

    return isVideo ? (
      <div style={{ position: "relative", width: "100%", height: "100%" }}>
        <video
          ref={this.state.videoRefsHome[index]}
          src={postFile.link}
          className="postVideoImage postVideoImageCover"
          style={styles.widgetMedia}
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          webkit-playsinline="true"
          data-video-index={index}
          onLoadedMetadata={(e) => {
            const video = e.currentTarget;
            video.style.objectFit = video.videoWidth > video.videoHeight ? 'contain' : 'cover';
          }}
          onCanPlay={(e) => {
            e.currentTarget.play().catch(() => { });
          }}
          onClick={() => this.toggleVideoSound(index)}
        />

        {/* FLASH */}
        {isFlashing && (
          <div
            key={`flash-${index}-${isFlashing}`}
            style={styles.soundFlashOverlay}
          >
            <div style={styles.soundFlashBadge}>
              {isSoundEnabled ? (
                <VolumeUpRoundedIcon style={styles.soundFlashIcon} />
              ) : (
                <VolumeOffRoundedIcon style={styles.soundFlashIcon} />
              )}
            </div>
          </div>
        )}

        {/* MUTE BUTTON */}
        <button
          type="button"
          aria-label={isSoundEnabled ? "Mute video" : "Unmute video"}
          // className="muteButton"
          onClick={(e) => {
            e.stopPropagation();
            this.toggleVideoSound(index);
          }}
          style={styles.muteToggleButton}
        >
          {isSoundEnabled ? (
            <VolumeUpRoundedIcon style={styles.muteToggleIcon} />
          ) : (
            <VolumeOffRoundedIcon style={styles.muteToggleIcon} />
          )}
        </button>
      </div>
    ) : (
      <img
        src={postFile.link}
        alt=""
        className="postVideoImage postVideoImageCover"
        onLoad={(e) => {
          const img = e.currentTarget;

          img.style.objectFit =
            img.naturalWidth > img.naturalHeight ? "contain" : "cover";
        }}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    );
  }

  handleDescription = (data: string) => {
    return data ? data : ""
  }

  renderUploadedReplyImage() {
    const { uploadedReplyImage } = this.state;

    if (!uploadedReplyImage) return null;

    return (
      <div
        style={{
          display: "inline-block",
          position: "relative",
          marginBottom: "10px",
        }}
      >
        <img
          data-test-id="uploaded-image-preview"
          src={uploadedReplyImage}
          alt="Uploaded preview"
          style={{
            width: "50px",
            height: "50px",
            borderRadius: "6px",
            objectFit: "cover",
          }}
        />

        <button
          data-test-id="cancelUploadReply"
          onClick={this.cancelUploadReplyImage}
          style={{
            position: "absolute",
            top: "-6px",
            right: "-6px",
            background: "#000",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            width: "18px",
            height: "18px",
            cursor: "pointer",
            fontSize: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          aria-label="Cancel upload"
        >
          ×
        </button>
      </div>
    );
  }

  renderUploadedImage() {
    const { uploadedImage } = this.state;

    if (!uploadedImage) return null;

    return (
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', position: 'relative' }}>
        <img
          src={uploadedImage}
          alt="Uploaded preview"
          style={{
            maxWidth: '50px',
            maxHeight: '70px',
            marginRight: '10px',
            borderRadius: '4px',
          }}
        />
        <button
          data-test-id="cancelUpload"
          onClick={() => this.setState({ uploadedImage: null, uploadedImageFile: null })}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: 'red',
            fontSize: '20px',
            position: 'absolute',
            top: '-12px',
            right: '404px',
          }}
          aria-label="Cancel upload"
        >
          &times;
        </button>
      </div>
    );
  }

  renderComment = (comment: any, postId: any) => {
    const full_name = comment.attributes.account.data.attributes.full_name;
    const first_name = comment.attributes.account.data.attributes.first_name;
    const business_name = comment.attributes.account.data.attributes.business_name;
    const profile_pic = comment.attributes.account.data.attributes.profile_pic;
    const { comment: commentText = "", created_at = "" } = comment.attributes || {};
    const formattedTimeAgo = this.timeAgo(created_at);
    const replies = Array.isArray(comment.attributes.replies?.data) ? comment.attributes.replies.data : [];
    const imageUrl = comment.attributes.files?.length > 0 ? comment.attributes.files[0].url : null;
    return (
      <Box key={comment.id} style={{ display: "flex", justifyContent: "space-between", padding: '10px 0' }}>
        <Box>
          <Box data-test-id="commentContainer" style={styles.commentUserContainer}>
            <div style={{ display: 'flex', gap: '6px' }}>
              <div data-test-id="profilePic">
                {profile_pic ? (
                  <img src={profile_pic.url} style={styles.userIcon} />
                ) : (
                  <Box style={styles.initialIcon}></Box>
                )}
              </div>
              <div>
                <div>
                  <div style={{ display: 'flex', justifyContent: "space-between", fontSize: '14px', padding: "10px 0px 0px 10px" }}>
                    <div data-test-id="fullName" style={styles.nameComment}>{full_name || first_name || "Anonymous"}</div>
                    <div style={styles.nameCommentTime} >{formattedTimeAgo}</div>
                  </div>
                  <p data-test-id="commentText" style={styles.userName}>{commentText}</p>
                  {imageUrl && (
                    <img
                      src={imageUrl}
                      alt="Uploaded"
                      style={{ maxWidth: '100%', borderRadius: '8px' }}
                    />
                  )}
                </div>
                <div style={{ display: 'flex', gap: '8px', fontSize: '14px', alignItems: 'center' }}>
                  <Box data-test-id="commentLike" onClick={() => comment.attributes.already_liked ? this.undoLike(comment.id, comment.attributes.commentable_id) : this.handleLike(comment.id, comment.attributes.commentable_id)}>
                    <Box style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <Box>
                        {comment.attributes.already_liked ? (
                          <FavoriteIcon style={{ color: 'red' }} />
                        ) : (
                          <FavoriteBorderIcon style={{ color: 'inherit' }} />
                        )}
                      </Box>
                      <Box>
                        <Typography variant="caption" style={{ marginLeft: '8px' }}>
                          {`${comment.attributes.likes_count} likes`}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  <p data-test-id="commentReply" onClick={() => this.handleReplyClick(comment.id)}>Reply</p>
                  <p>
                    {`View ${replies.length} ${replies.length === 1 ? 'reply' : 'replies'}`}
                  </p>
                  <KeyboardArrowDown data-test-id="replyVisibility" onClick={() => this.toggleRepliesVisibility(comment.id)} />
                </div>
                {this.state.replyToCommentId === comment.id && (
                  <div style={styles.replyInput}>
                    <input
                      type="file"
                      id="fileInputReply"
                      accept="image/*"
                      data-test-id="input-tag"
                      onChange={this.handleReplyImageUpload}
                      style={{ display: "none" }}
                      ref={this.fileInputReply}
                    />
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      {this.renderUploadedReplyImage()}
                      <div style={{ display: "flex" }}>
                        {this.state.photoVideoEnabled && this.state.euMediaPermission && (
                          <label htmlFor="fileInputReply">
                            <div data-test-id="fileInput" style={{ marginRight: "10px" }} onClick={this.handleFileInputClick}>
                              <img src={uploadIcon} alt="upload icon" />
                            </div>
                          </label>
                        )}
                        <TextField
                          variant="outlined"
                          fullWidth
                          style={styles.reply}
                          value={this.state.replyText}
                          onChange={this.handleReplyChange}
                          placeholder="Write a reply..."
                        />
                        <Box
                          color="primary"
                          style={{ marginLeft: "7px" }}
                          data-test-id="sendReplyIcon"
                          onClick={() => this.handleReplySubmit(comment.attributes.commentable_id)}
                        >
                          <img src={sendMedssageIcon} alt="sendIcon" />
                        </Box>
                        <p
                          data-test-id="sendReplyCancel"
                          onClick={() => this.setState({ replyToCommentId: null, replyText: '' })}
                          style={{ marginLeft: '10px', cursor: 'pointer', color: '#007BFF' }}
                        >
                          Cancel
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                {/* Replies Section */}
                {this.renderReplies(replies, comment)}
              </div>
            </div>
          </Box>
        </Box>
        <Box>
          <IconButton data-test-id="openPopover" onClick={(event) => this.openActionPopover(event, postId, comment.id)}>
            <MoreHorizIcon />
          </IconButton>
        </Box>
      </Box>
    );
  };

  renderReplies = (replies: any[], comment: { id: string | number; }) => {
    const isRepliesVisible = this.state.repliesVisible?.[comment.id];

    return (
      <>
        {isRepliesVisible && (
          <Box style={{ marginLeft: "30px", marginTop: "10px" }}>
            {replies.map((reply) => (
              <Box key={reply.id} style={{ display: "flex", gap: "10px", padding: "5px 0" }}>
                <div>
                  <img data-test-id="replyImage" src={reply.attributes?.account?.data.attributes.profile_pic?.url || ""} style={styles.userIcon} />
                </div>
                <div style={{ backgroundColor: '#f1f1f1', borderRadius: '8px', padding: '10px' }}>
                  <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>
                      {reply.attributes?.account?.data.attributes.full_name || reply.attributes?.account?.data.attributes.first_name || "Anonymous"}
                    </span>
                    <span style={{ fontSize: '12px', color: '#888' }}>
                      {this.timeAgo(reply.attributes.created_at)}
                    </span>
                  </Box>
                  <Box style={{ display: "flex" }}>
                    <Box>
                      <p>{reply.attributes.comment}</p>
                      {reply.attributes?.files?.length > 0 && reply.attributes.files.map((file: { url: string | undefined; }) => (
                        <img
                          data-test-id="replyimg"
                          src={file.url}
                          alt="Uploaded"
                          style={{ maxWidth: '100%', borderRadius: '8px' }}
                        />
                      ))}
                    </Box>
                    <Box>
                      <IconButton>
                        <MoreHorizIcon />
                      </IconButton>
                    </Box>
                  </Box>
                </div>
              </Box>
            ))}
          </Box>
        )}
      </>
    );
  };

  renderPoll(poll: any, poll_options: any, account_profile: { url: string | undefined; }, postId: string) {
    return (
      poll && (
        <Poll
          data-test-id="poll"
          poll={poll}
          poll_options={poll_options}
          accountProfile={account_profile?.url}
          handleVote={(optionId: number) => this.props.handleVote(optionId, postId)}
          handleDeleteVote={(optionId: number) =>
            this.props.handleDeleteVote(optionId, postId)
          }
        />
      )
    );
  }

  getCommentsUI = () => {
    const { isCommentsLoading } = this.state;
    const commentsArray = Array.isArray(this.state.allCommentsData?.data)
      ? this.state.allCommentsData!.data
      : [];
    return (
      <>
        {/* SCROLLABLE COMMENTS */}
        <Box
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "0 16px",
          }}
        >

          {isCommentsLoading ? (
            <Box style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "40px 0" }}>
              <CircularProgress size={28} style={{ color: "#64748B" }} />
            </Box>
          ) : commentsArray.length > 0 ? (
            commentsArray.map((item: any) => {
              const attr = item.attributes;
              const account =
                attr?.account?.data?.attributes;

              return (
                <Box
                  key={item.id}
                  style={{
                    display: "flex",
                    marginBottom: "16px",
                    alignItems: "flex-start",
                  }}
                >
                  {/* Avatar */}
                  <img
                    src={
                      account?.profile_pic?.url ||
                      IconAvtar
                    }
                    alt="avatar"
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: "50%",
                      marginRight: 10,
                      objectFit: "cover",
                    }}
                  />

                  {/* Content */}
                  <Box style={{ flex: 1 }}>
                    {/* Username + Comment */}
                    <Box>
                      {/* First Line - Name */}
                      <Typography
                        style={{
                          fontWeight: 600,
                          fontSize: "14px",
                          lineHeight: "18px",
                          color: "#000",
                          fontFamily: "Inter",
                        }}
                      >
                        {account?.first_name} {account?.last_name} <span style={{ fontSize: "12px", color: "#8e8e8e", fontFamily: "Inter" }}>{this.timeAgo(attr?.created_at)}</span>
                      </Typography>

                      {/* Second Line - Comment */}
                      <Typography
                        style={{
                          color: "#0F172A",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          fontFamily: "Inter",
                          wordBreak: "break-word",
                          whiteSpace: "pre-line",
                        }}
                      >
                        {attr?.comment}
                      </Typography>
                    </Box>


                    {/* Time + Reply */}
                    <Box
                      style={{
                        display: "flex",
                        gap: "15px",
                        marginTop: 4,
                        alignItems: "center",
                      }}
                    >
                      <Box
                        data-test-id="reactonButtonsOfReply"
                      >
                        <IconButton aria-label="post-likes" onClick={() => this.handleReplyLike(item.id)} style={{ padding: '0px' }}>
                          <img src={item.attributes.already_liked ? redHeart : HeartSmallIcon} style={{ width: "20px", height: "20px" }} />
                        </IconButton>
                        <Typography
                          component="span"
                          style={{
                            color: "#64748B",
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "22px",
                            marginLeft: "5px",
                          }}
                        >
                          {item.attributes.likes_count}
                        </Typography>
                      </Box>


                      <Typography
                        style={{
                          fontSize: 12,
                          color: "#8e8e8e",
                          cursor: "pointer",
                          fontWeight: 500,
                        }}
                        onClick={() =>
                          this.handleReplyClick(item.id)
                        }
                      >
                        Reply
                      </Typography>
                    </Box>
                  </Box>

                  {/* Like */}
                  <IconButton
                    size="small"
                    // onClick={(event: any) => {
                    //   handleClick(event);
                    //   handleCommentClick(item.attributes?.account_id);
                    //   setReplyingToName(
                    //     commonFunctionForCondition(
                    //       item.attributes?.account.data.attributes
                    //         .first_name !== null,
                    //       item.attributes?.account.data.attributes
                    //         .first_name,
                    //       ""
                    //     ) +
                    //       " " +
                    //       commonFunctionForCondition(
                    //         item.attributes?.account.data.attributes
                    //           .last_name !== null,
                    //         item.attributes?.account.data.attributes
                    //           .last_name,
                    //         ""
                    //       )
                    //   );
                    //   setSelectedCommentId(item.attributes?.id);
                    //   setSelectedComment(item);
                    // }}
                    aria-label="post-settings"
                    // className={classes.postSettingsBtn}
                    data-test-id="threeDotIconPopOver"
                  >
                    <MoreVertIcon data-test-id="commentMore" />
                  </IconButton>
                </Box>
              );
            })
          ) : (
            <Box
              style={{
                textAlign: 'center',
                padding: '20px 20px',
                color: '#666',
                fontSize: '16px'
              }}
            >
              <Typography variant="body1" style={{ color: '#999', fontSize: '14px' }}>
                No comments yet
              </Typography>
              <Typography variant="body2" style={{ color: '#ccc', fontSize: '12px', marginTop: '8px' }}>
                Be the first to comment!
              </Typography>
            </Box>
          )}
        </Box>

        {/* FIXED INPUT SECTION */}
        {this.renderUploadedImage()}
        <Box
          alignItems="center"
          //  className={classes.postCommentRoot}
          style={{
            margin: 0, padding: 0, display: "flex",
            width: "100%",
            flexShrink: 0, marginBottom: "10px"
          }}
        >
          <Box>
            {window.localStorage.getItem("EUAuthToken") && this.state.photoVideoEnabled && this.state.euMediaPermission ? (
              <IconButton
                style={{ paddingLeft: "8px" }}
                data-test-id="image-comment-upload"
                aria-label="add image"
                onClick={this.handleFileInputClick1}
              >
                <img
                  src={uploadIcon}
                  alt="uploadIcon"
                />
                <input
                  ref={this.fileInput}
                  accept=".jpeg, .jpg, .png"
                  type="file"
                  hidden
                  data-test-id="image-comment-file"
                  capture={this.isMobileViewport() ? "environment" : undefined}
                  onChange={this.handleImageUpload}
                />
              </IconButton>
            ) : (
              <img
                src={
                  this.state.posts.find(
                    (p) => String(p.id) === String(this.state.currentCommentsPostId)
                  )?.attributes?.account_profile?.url || EverybrandIcon
                }
                alt="brand profile"
                style={{ width: "44px", height: "44px", borderRadius: "50%", objectFit: "cover", marginLeft: "8px", marginRight: '8px' }}
              />
            )}
          </Box>
          <Box style={{ width: '98%' }}>
            <Box>
              <TextField
                data-test-id="commentField"
                placeholder="Add a Comment"
                variant="outlined"
                value={this.state.localCommentText}
                fullWidth
                multiline
                maxRows={6}
                minRows={1}
                name="comment"
                onChange={this.handleLocalCommentTextChange}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey && this.state.localCommentText.trim()) {
                    e.preventDefault();
                    this.handleCommentPostClick(this.state.currentCommentsPostId as string);
                  }
                }}
              />
            </Box>
          </Box>
          <Box>
            <IconButton
              size="small"
              data-test-id="postCommentApiCall"
              disabled={!this.state.localCommentText.trim()}
              onClick={() => this.handleCommentPostClick(this.state.currentCommentsPostId as string)}
            >
              <img src={sendMedssageIcon} alt="sendIcon" />
            </IconButton>
          </Box>
        </Box>
      </>
    );
  };


  inputRefs = Array.from({ length: 6 }, () =>
    React.createRef<HTMLInputElement>()
  );
  render() {

    const { navigation } = this.props
    const { posts, suggestedBrandsHome, top6, anchorEl, allCommentsData, anchorElSettingIcon } = this.state;
    const open = Boolean(anchorEl);
    const isOpen = Boolean(anchorElSettingIcon)

    return (
      <>
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "#000",
            overflow: "hidden",
          }}
        >
          {/* ================= TOP NAV (desktop only) ================= */}
          {/* <div className="eu-topnav-desktop-only">
            {!this.state.isWidget && (
              <NavigationMenuEUWeb brands={this.state.brandsIFollowHome} />
            )}
          </div> */}

          {/* ================= REELS SCROLL AREA ================= */}
          <div
            ref={this.homeRef}
            data-test-id="eu-home-wrapper"
            style={{
              position: "absolute",
              inset: 0,
              overflowY: "auto",
              WebkitOverflowScrolling: "touch",
              scrollSnapType: "y mandatory",
              background: "#000",

              // hide scrollbar (Firefox)
              scrollbarWidth: "none",

              // hide scrollbar (IE/Edge old)
              msOverflowStyle: "none",
            }}
          >
            {/* TOP TABS */}
            {this.state.isWidget && (
              <Box
                style={{
                  position: "fixed",
                  top: 20,
                  width: "100%",
                  zIndex: 1000,
                  display: "flex",
                  justifyContent: "center",
                  gap: 15,
                }}
              >
                <Typography
                  onClick={() => this.switchWidgetFeedTab(true)}
                  style={{
                    color: this.state.isDashboard ? "#fff" : "rgba(255,255,255,0.6)",
                    fontWeight: 700,
                    cursor: "pointer",
                  }}
                >
                  HOME
                </Typography>

                <Typography
                  onClick={() => this.switchWidgetFeedTab(false)}
                  style={{
                    color: !this.state.isDashboard ? "#fff" : "rgba(255,255,255,0.6)",
                    fontWeight: 700,
                    cursor: "pointer",
                  }}
                >
                  DAILY
                </Typography>
              </Box>
            )}

            {/* ================= POSTS ================= */}
            <div style={{ width: "100%" }}>
              {posts?.map((post, index) => {
                const postFile = post.attributes.files?.[0];
                if (!postFile) return null;

                const amountLike = post.attributes.likes_count || 0;
                const isLiked = post.attributes.is_liked;

                const commentsCount = Array.isArray(post.attributes.comments?.data)
                  ? post.attributes.comments.data.length
                  : post.attributes.comments_count || 0;

                const profileUrl = post.attributes.account_profile?.url || "";
                const accountId = post.attributes.account_id || 0;

                return (
                  <div
                    key={post.id}
                    className="imageContainer"
                    style={{
                      height: "93%",
                      width: "100%",
                      scrollSnapAlign: "start",
                      // scrollSnapStop: "always",
                      position: "relative",
                      background: "#000",
                    }}
                  >
                    {/* MEDIA */}
                    <div style={{ position: "absolute", inset: 0 }}>
                      {this.handleFileRender(postFile, index)}
                    </div>

                    {/* OVERLAY */}
                    <ReelBottomOverlay
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        zIndex: 10,
                      }}
                    >
                      <Box style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                        <PostInfo
                          title={post.attributes.body || ""}
                          firstName={post.attributes.account?.business_name}
                          lastName={post.attributes.account?.last_name}
                          description={this.handleDescription(
                            post.attributes.description
                          )}
                        />

                        {/* CHOICE BUTTONS */}
                        {/* {post.attributes.choices && post.attributes.choices.length > 0 && (
                          <Box style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "10px", paddingRight: "50px" }}>
                            {post.attributes.choices.map((choice, ci) => (
                              choice.button_type === "chat" && (
                                <button
                                  key={ci}
                                  onClick={() => this.setState({ chatModalOpen: true, chatName: "", chatPhone: "", chatMessage: "" })}
                                  style={{
                                    backgroundColor: "#FFC629",
                                    color: "#000",
                                    border: "none",
                                    borderRadius: "20px",
                                    padding: "8px 18px",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    fontFamily: "Inter",
                                    cursor: "pointer",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {choice.name || choice.button_name || "Chat"}
                                </button>
                              )
                            ))}
                          </Box>
                        )} */}
                      </Box>

                      <Box className="profileLikeCommentContainer" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "12px" }}>

                        {/* LEFT SIDE */}
                        <Box>
                          <ProfileIcon
                            imageUrl={profileUrl}
                            accountId={accountId}
                            handlePostProfileClick={this.handlePostProfileClick.bind(this)}
                          />
                        </Box>

                        {/* RIGHT SIDE STACK (LIKE YOUR HTML) */}

                        <LikeButton
                          data-test-id="likeBtnWrapper"
                          amount={amountLike}
                          isLiked={isLiked}
                          handleLikes={() => this.handlePostLikes(post.id)}
                        />

                        <CommentButton
                          amount={commentsCount}
                          data-test-id="commentBtn"
                          Id={post.id}
                          handleClick={this.toggleCommentBox.bind(this)}
                        />

                        {/* MORE BUTTON */}
                        <Box style={{ position: "relative" }}>
                          <IconButton
                            size="small"
                            onClick={(event) => this.handleClickPopOver(event, post.id)}
                            data-test-id="settingIconOpen"
                            style={styles.postSettingsBtn}
                          >
                            <MoreHorizRoundedIcon style={{ color: "white", fontSize: "28px" }} />
                          </IconButton>

                          <CustomPopOver
                            open={isOpen}
                            anchorEl={anchorElSettingIcon}
                            onClose={this.handleClosePopOver}
                            anchorOrigin={{ vertical: "center", horizontal: "left" }}
                            transformOrigin={{ vertical: "center", horizontal: "right" }}
                          >
                            <div
                              onClick={() => this.hidePostApicall(post.id)}
                              style={{ textAlign: "center", cursor: "pointer" }}
                            >
                              Report this post
                            </div>
                          </CustomPopOver>
                        </Box>


                      </Box>
                    </ReelBottomOverlay>
                  </div>
                );
              })}
            </div>

            <CustomLoader
              loaderSize={24}
              isLoading={this.state.isEUHomePostLoading}
            />
          </div>

          {/* ================= FIXED BOTTOM NAVBAR (IMPORTANT) ================= */}
          <div
            style={{
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              height: "60px",
              zIndex: 9999999,
              background: "#000",
            }}
          >
            <MobileNavEndUser navigation={navigation} />
          </div>
        </div>

        {/* ================= MODALS ================= */}
        {this.state.commentModalOpen && (
          <Modal
            open={this.state.commentModalOpen}
            onClose={this.handleHardCloseCommentModal}
            data-test-id="commentOptionsModal"
          >
            <Box
              style={{
                position: "fixed",
                bottom: "var(--eu-mobile-tabbar-height, 0px)",
                left: 0,
                right: 0,
                height: "85vh",
                maxHeight: "48%",
                backgroundColor: "#fff",
                zIndex: 3000,
                borderTopLeftRadius: "20px",
                borderTopRightRadius: "20px",
                display: "flex",
                flexDirection: "column",
                boxShadow: "0 -2px 10px rgba(0,0,0,0.15)",
              }}
            >
              {/* Drag Handle */}
              <div style={{
                display: "flex",
                flexDirection: "column",
                padding: "12px 20px 16px 20px",
                backgroundColor: "transparent",
                position: "relative"
              }}>
                <div style={{
                  width: "40px",
                  height: "4px",
                  backgroundColor: "rgba(0, 0, 0, 0.3)",
                  borderRadius: "2px",
                  margin: "0 auto 12px auto"
                }}></div>

                <div style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px"
                }}>
                  <div style={{
                    color: "black",
                    fontSize: "18px",
                    fontWeight: "bold",
                    fontFamily: "inter"
                  }}>
                    Comments
                  </div>
                </div>

                <button
                  onClick={this.handleHardCloseCommentModal}
                  style={{
                    color: "black",
                    backgroundColor: "white",
                    border: "1px solid #ddd",
                    padding: "4px",
                    position: "absolute",
                    right: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "16px",
                    width: "20px",
                    height: "20px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 3001
                  }}
                >
                  ✕
                </button>
              </div>

              {this.getCommentsUI()}
            </Box>
          </Modal>
        )}

        {/* ===== COMMENT ONBOARDING MODAL ===== */}
        <CommentOnboardingModal
          open={this.state.commentOnboardStep > 0}
          step={this.state.commentOnboardStep}
          firstName={this.state.commentOnboardFirstName}
          lastName={this.state.commentOnboardLastName}
          phone={this.state.commentOnboardPhone}
          otp={this.state.commentOnboardOtp}
          phoneError={this.state.commentOnboardPhoneError}
          otpError={this.state.commentOnboardOtpError}
          loading={this.state.commentOnboardLoading}
          isNewAccount={this.state.commentOnboardIsNewAccount}
          onClose={() => this.setState({ commentOnboardStep: 0 })}
          onBack={this.handleCommentOnboardBack}
          onFirstNameChange={v => this.setState({ commentOnboardFirstName: v })}
          onLastNameChange={v => this.setState({ commentOnboardLastName: v })}
          onContinueFromName={() => this.setState({ commentOnboardStep: 2 })}
          onPhoneChange={v => this.setState({ commentOnboardPhone: v, commentOnboardPhoneError: "" })}
          onSendOtp={this.handleCommentOnboardSendOtp}
          onOtpChange={otp => this.setState({ commentOnboardOtp: otp, commentOnboardOtpError: "" })}
          onVerifyOtp={this.handleCommentOnboardVerifyOtp}
          onChangePhone={() => this.setState({ commentOnboardStep: 2, commentOnboardOtp: Array(6).fill("") })}
          onResendOtp={this.handleCommentResendOtp}
          onPost={this.handleCommentOnboardPost}
        />

        <Modal
          open={this.state.reviewModal}
          onClose={() => this.setState({ reviewModal: false, reviewStep: 1, reviewRating: 0, reviewDescription: "", reviewName: "", reviewPhone: "", reviewOtp: Array(6).fill(""), reviewPhoneError: "", reviewOtpError: "" })}
          style={{ display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1400 }}
        >
          <div style={{ background: "#fff", width: "100%", maxWidth: 480, maxHeight: "90vh", overflowY: "auto", borderRadius: 12, outline: "none" }}>
            <Box style={{ display: "flex", justifyContent: "flex-end", padding: "8px 16px" }}>
              <IconButton size="small" onClick={() => this.setState({ reviewModal: false, reviewStep: 1, reviewRating: 0, reviewDescription: "", reviewName: "", reviewPhone: "", reviewOtp: Array(6).fill(""), reviewPhoneError: "", reviewOtpError: "" })}>
                <CloseIcon style={{ fontSize: 20 }} />
              </IconButton>
            </Box>

            <Box style={{ padding: "0 24px 16px", textAlign: "center" }}>
              {/* Step 1: Name */}
              {this.state.reviewStep === 1 && (
                <>
                  <Typography variant="caption" gutterBottom display="block">
                    {`Great start! Let's add a personal touch to your review. What's your first and last name?`}
                  </Typography>
                  <TextField variant="outlined" fullWidth value={this.state.reviewName} onChange={e => { const cleaned = e.target.value.replace(/\s+/g, " "); if (cleaned.trim().split(" ").filter(Boolean).length <= 2) this.setState({ reviewName: cleaned }); }} placeholder="Enter your name" style={{ marginTop: 16 }} />
                </>
              )}

              {/* Step 2: Phone */}
              {this.state.reviewStep === 2 && (
                <>
                  <Box style={{ marginTop: 16 }}>
                    <PhoneInput
                      data-test-id="userNumber"
                      country={"us"}
                      value={this.state.reviewPhone}
                      onChange={(value: any) =>
                        this.setState({
                          reviewPhone: value,
                          reviewPhoneError: "",
                        })
                      }
                      placeholder="Add Your Phone number"
                      specialLabel=""
                      buttonStyle={{
                        border: "1px solid #ccc",
                        borderRight: "none",
                        borderRadius: "8px 0 0 8px",
                        background: "#fff",
                      }}
                      inputStyle={{
                        width: "100%",
                        height: "48px",
                        padding: "12px 12px 12px 48px",
                        fontSize: 16,
                        border: "1px solid #ccc",
                        borderRadius: 8,
                        boxSizing: "border-box",
                      }}
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </Box>
                  {this.state.reviewPhoneError && <Typography variant="caption" style={{ color: "#f44336" }}>{this.state.reviewPhoneError}</Typography>}
                  <Typography variant="caption" display="block" style={{ marginTop: 8 }}>{`By tapping "continue" you agree to our privacy policy and terms of service and authorize Everybrand to send you text message to the mobile number provided. Message/data rates may apply.`}</Typography>
                </>
              )}

              {/* Step 3: OTP */}
              {this.state.reviewStep === 3 && (
                <>
                  <Typography variant="caption" display="block" gutterBottom>Enter the code we sent to +1 {this.state.reviewPhone}</Typography>
                  <Box style={{ display: "flex", justifyContent: "space-between", margin: "16px 0" }}>
                    {this.state.reviewOtp.map((val, index) => (
                      // <TextField
                      //   key={index}
                      //   value={val}
                      // onChange={e => {
                      //   const digit = e.target.value.replace(/\D/g, "").slice(-1);
                      //   const newOtp = [...this.state.reviewOtp];
                      //   newOtp[index] = digit;
                      //   this.setState({ reviewOtp: newOtp });
                      // }}
                      //   variant="outlined"
                      //   style={{ width: "14%" }}
                      //   inputProps={{ maxLength: 1, style: { textAlign: "center" } }}
                      // />
                      <TextField
                        key={index}
                        data-test-id={`codeInput-${index}`}
                        autoFocus={index === 0}
                        inputRef={this.inputRefs[index]}
                        value={val}
                        onChange={(e) => {
                          const digit = e.target.value.replace(/\D/g, "").slice(-1);

                          const newOtp = [...this.state.reviewOtp];
                          newOtp[index] = digit;

                          this.setState({ reviewOtp: newOtp });

                          if (digit && index < this.inputRefs.length - 1) {
                            this.inputRefs[index + 1].current?.focus();
                          }
                        }}
                        variant="outlined"
                        // className={classes.otpInput}
                        inputProps={{
                          maxLength: 1,
                          style: { textAlign: "center" },
                        }}
                        onKeyDown={(e) => this.handleOtpKeyDown(e, index)}
                      />
                    ))}
                  </Box>
                  {this.state.reviewOtpError && <Typography variant="caption" style={{ color: "#f44336" }}>{this.state.reviewOtpError}</Typography>}
                  <Button color="primary" onClick={() => this.setState({ reviewStep: 2 })}>Change the phone number</Button>
                </>
              )}

              {/* Step 4: Success */}
              {this.state.reviewStep === 4 && (
                <Box style={{ textAlign: "left", padding: 16 }}>
                  <Box style={{ display: "flex", gap: 8 }}>
                    <Box style={{ width: 40, height: 40, borderRadius: "50%", backgroundColor: "#f1d17885", border: "3px solid #f4b914", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold", flexShrink: 0 }}>
                      {this.state.reviewName ? this.state.reviewName.charAt(0).toUpperCase() : "UN"}
                    </Box>
                    <Box>
                      <Box style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        <Typography style={{ fontSize: 13, color: "rgb(72 115 165)", fontWeight: "bold" }}>{this.state.reviewName || "User Name"}</Typography>
                        <span style={{ color: "#FFC629", fontSize: 14 }}>{"★".repeat(this.state.reviewRating)}</span>
                      </Box>
                      <Typography style={{ fontSize: 13, color: "#333", marginTop: 4 }}>{this.state.reviewDescription || "Your review text will appear here..."}</Typography>
                    </Box>
                  </Box>
                  <Typography variant="caption" color="textSecondary" style={{ display: "block", marginTop: 36 }}>
                    Congratulations! Your profile has been created. Once the button below to your community can see your Review.
                  </Typography>
                </Box>
              )}
            </Box>

            <Box style={{ padding: "0 24px 24px" }}>
              <Button
                variant="contained"
                fullWidth
                disabled={this.state.reviewLoading}
                onClick={() => {
                  if (this.state.reviewStep === 4) {
                    this.handleSubmitReview();
                  } else {
                    this.setState({ reviewStep: Math.min(this.state.reviewStep + 1, 4) });
                  }
                }}
                style={{ backgroundColor: "#000", color: "#fff", borderRadius: 20, textTransform: "none" }}
              >
                {this.state.reviewStep === 4
                  ? (this.state.reviewLoading ? <CircularProgress size={20} style={{ color: "#fff" }} /> : "Post")
                  : "Continue"}
              </Button>
            </Box>
          </div>
        </Modal>
      </>
    );
  }
}
const StyledMenuItem = withStyles((theme) => ({
  root: {
    "&:focus": {
      backgroundColor: "#FFC629",
      borderRadius: "8px",
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: "#0F172A",
      },
    },
  },
}))(MenuItem);

const styles = {
  title: {
    marginRight: "15px"
  },

  mainContainer: {
    width: "100vw",
    maxWidth: "1240px",
    margin: "15px auto",
    paddingBottom: "80px",
    "@media (minWidth: 960px)": {
      paddingBottom: "15px"
    }
  } as React.CSSProperties,

  contentContainer: {
    padding: "0px 20px",
    display: "flex",
    gap: "15px",
    justifyContent: "center",
  },

  popOverPaper: {
    padding: "4px 4px 2px 4px",
    borderRadius: "8px",
    border: "1px solid #E2E8F0",
    minWidth: "192px",
    height: "53px",
    background: "#FFF",
    boxShadow:
      "none",
    zIndex: 4000,
  },

  sideContainer: {
    width: "30%",
  } as React.CSSProperties,

  heading: {
    scrollSnapAlign: "center",
    margin: "30px 0 -40px 30px",
    fontFamily: "Inter",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 700,
    display: "flex",
  },
  commentOptionsModalBox: {
    backgroundColor: "#fff",
    padding: "8px",
    borderRadius: "12px",
    minWidth: "240px",
    outline: "none",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
  },

  uploadVideoCommentButton: {
    backgroundColor: "#000",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "12px 16px",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "24px",
    cursor: "pointer",
    width: "100%",
    textAlign: "center",
    minHeight: "44px", // Minimum touch target size for mobile
    touchAction: "manipulation", // Improve touch responsiveness
    WebkitTapHighlightColor: "transparent", // Remove tap highlight on mobile
    "&:hover": {
      backgroundColor: "#333",
    },
    "&:active": {
      backgroundColor: "#555",
    },
  },
  image: {
    borderRadius: "10px",
    width: "100%",
    height: "calc(100vh - 200px)",
  },

  commentIcon: {
    position: "absolute" as const,
    bottom: '50px',
    right: "5px"
  },

  commentImg: {
    width: "24px",
    height: "24px"
  },

  commentBox: {
    maxHeight: '450px',
    bottom: "var(--eu-mobile-tabbar-height, 0px)",
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    padding: '10px',
    borderTop: '1px solid #ccc',
    zIndex: 3000,
    position: "absolute" as 'absolute',
    borderRadius: "8px"
  },

  commentsList: {
    maxHeight: '300px',
    overflowY: 'scroll' as const,
    overflowX: "hidden" as const
  },
  popovertext: {
    fontSize: "14px",
    fontWeight: 400,
    fontFamily: "Inter",
    marginTop: "17px"
  },

  commentItem: {
    padding: '10px',
    backgroundColor: '#f1f1f1',
    borderRadius: '8px',
    marginBottom: '10px',
  },

  commentText: {
    color: '#000000',
    fontSize: '14px',
    maxWidth: '85%',
    wordWrap: 'break-word' as const,
  },

  commentInputContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '10px',
  },

  sendIconButton: {
    marginLeft: '10px',
  },

  moreVertIcon: {
    color: '#888888',
  },

  userIcon: {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    objectFit: 'cover' as const,
    flexShrink: 0,
    display: 'block',
    padding: '10px',
  },

  initialIcon: {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    backgroundColor: '#888888',
    color: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '18px',
    fontWeight: 'bold' as const,
  },

  userName: {
    fontWeight: 400,
    fontSize: '16px',
    color: '#000',
    fontFamily: "Inter",
    paddingRight: '10px',
    paddingLeft: '12px',
    paddingBottom: "10px",
    borderRadius: '6px',
  },

  commentUserContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  postSettingsBtn: {
    color: "#0F172A",
  },

  commentCount: {
    fontSize: '14px',
    color: '#FFFFFF',
  },

  // Widget Specific Styles
  widgetContainer: {
    position: 'relative' as 'relative',
    width: '100%',
    height: '91%',
    scrollSnapAlign: 'start',
    backgroundColor: '#000',
    overflow: 'hidden',
    // scrollSnapAlign: 'start' as 'start',
    scrollSnapStop: 'always' as 'always',
  },
  widgetMediaWrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  widgetMedia: {
    width: '100%',
    height: '100%',
    objectFit: 'cover' as 'cover',
    backgroundColor: '#000',
  },
  soundFlashOverlay: {
    position: 'absolute' as 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
    pointerEvents: 'none' as 'none',
    animation: 'soundFlashFade 0.6s ease-out forwards',
  },
  soundFlashBadge: {
    width: '80px',
    height: '80px',
    // borderRadius: '50%',
    backgroundColor: 'transprent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    borderRadius: '999px',
    border: '1px solid #fff',
  },
  soundFlashIcon: {
    fontSize: '40px',
    lineHeight: 1,
    color: '#fff'
  },
  tapForSoundHint: {
    position: 'absolute' as 'absolute',
    top: '16px',
    left: '12px',
    zIndex: 6,
    color: '#fff',
    fontSize: '12px',
    fontWeight: 600,
    letterSpacing: '0.2px',
    padding: '8px 10px',
    borderRadius: '999px',
    backgroundColor: 'rgba(0,0,0,0.55)',
    pointerEvents: 'none' as 'none',
  },
  muteToggleButton: {
    position: 'absolute' as const,
    left: '10px',
    bottom: '70px',
    zIndex: 12,

    width: '30px',
    height: '30px',
    border: 'none',

    background: 'transparent',
    backgroundColor: 'transparent',

    color: '#fff',

    // outline: 'none',
    cursor: 'pointer',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    padding: 0,
  },

  muteToggleIcon: {
    color: '#fff',
    fontSize: '20px',
  },
  widgetGradientOverlay: {
    position: 'absolute' as 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0) 25%, rgba(0,0,0,0) 60%, rgba(0,0,0,0.8) 100%)',
    pointerEvents: 'none' as 'none'
  },
  widgetRightActions: {
    position: 'absolute' as 'absolute',
    right: 15,
    bottom: 120,
    display: 'flex',
    flexDirection: 'column' as 'column',
    alignItems: 'center',
    gap: 25,
    zIndex: 5
  },
  widgetProfileImg: {
    width: 50,
    height: 50,
    borderRadius: '50%',
    border: '1px solid #fff',
    objectFit: 'cover' as 'cover'
  },
  widgetPlusIcon: {
    position: 'absolute' as 'absolute',
    bottom: -8,
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: '#FF2D55',
    color: '#fff',
    borderRadius: '50%',
    width: 20,
    height: 20,
    fontSize: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold' as 'bold'
  },
  widgetActionItem: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    alignItems: 'center'
  },
  widgetActionText: {
    color: '#fff',
    fontSize: 13,
    marginTop: 5,
    fontWeight: 600,
    textShadow: '0 1px 2px rgba(0,0,0,0.5)'
  },
  widgetBottomInfo: {
    position: 'absolute' as 'absolute',
    bottom: 25,
    left: 15,
    maxWidth: '75%',
    zIndex: 5,
    color: '#fff',
    textAlign: 'left' as 'left'
  },
  widgetUserName: {
    fontWeight: 700,
    fontSize: 17,
    marginBottom: 8,
    textShadow: '0 1px 2px rgba(0,0,0,0.5)'
  },
  widgetDescription: {
    fontSize: 15,
    lineHeight: 1.4,
    marginBottom: 12,
    display: '-webkit-box',
    boxOrient: 'vertical',
    lineClamp: 2,
    overflow: 'hidden',
    textShadow: '0 1px 2px rgba(0,0,0,0.5)'
  },
  widgetMusicRow: {
    display: 'flex',
    alignItems: 'center'
  },
  comment: {
    marginBottom: "1em"
  },

  commentActions: {
    display: "flex",
    gap: "1em",
    marginTop: "0.5em",
  },

  replyInput: {
    display: "flex",
    alignItems: "center",
    marginTop: "0.5em",
  },

  reply: {
    fontSize: "0.9em",
    color: "#555"
  },

  navigationMenu: {
    transition: "transform 0.3s ease-out, opacity 0.3s ease-out",
    transform: "translateY(0)",
    opacity: "1"
  },

  slideUp: {
    transform: "translateY(-100%)",
    opacity: "0"
  },
  nameComment: {
    fontSize: "14px",
    fontFamily: "Inter"
  },
  nameCommentTime: {
    fontSize: "14px",
    fontFamily: "Inter",
    marginRight: "5px"
  },
  reelsContainer: {
    height: 'auto',
    width: '100%',
  },
};

const CustomPopOver = withStyles({
  paper: styles.popOverPaper,
})(Popover)

/** MUI v4 Box ignores `sx`; styled() keeps overlay + breakpoints working on mobile reels */
const ReelBottomOverlay = styled(Box)(({ theme }) => ({
  position: "absolute",
  bottom: "calc(var(--app-tabbar-height, 30px) + env(safe-area-inset-bottom, 0px))",
  left: 0,
  right: 0,
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "flex-end",
  padding: "0 16px 16px 16px",
  zIndex: 3,
  minHeight: "120px",
  pointerEvents: "auto",
  [theme.breakpoints.down("sm")]: {
    minHeight: "140px",
  },
}))

const EU_MOBILE_TABBAR = "calc(64px + env(safe-area-inset-bottom, 0px))";
/** Sticky EU AppBar + toolbar; keeps reel column from exceeding MainContainer (avoids clip / “white” gap) */
const EU_MOBILE_TOP_OFFSET = "56px";

const MainContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "#f1f4f9",
  minHeight: "100vh",

  [theme.breakpoints.down(960)]: {
    backgroundColor: "#000",
    width: "100%",
    height: "100vh",

    "@supports (height: 100vh)": {
      height: "100vh",
    },

    position: "relative", // IMPORTANT
    overflow: "hidden",   // ok now

    "--eu-mobile-tabbar-height": "calc(65px + env(safe-area-inset-bottom, 0px))",
    "--app-tabbar-height": "65px",

    "& .eu-topnav-desktop-only": {
      display: "none",
    },
  },
}));

const EuHomeOuter = styled("div")(({ theme }) => ({
  width: "100vw",
  maxWidth: "1240px",
  margin: "15px auto",
  paddingBottom: "80px",

  [theme.breakpoints.down(960)]: {
    width: "100%",
    maxWidth: "100%",
    margin: 0,
    paddingBottom: 0,
    flex: 1,
    minHeight: 0,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
}));

const ImageBox = styled(Box)(({ theme }) => ({
  backgroundColor: "#FFFFFF",
  maxWidth: "700px",
  width: "100%",
  height: "788px",
  maxHeight: "788px",
  overflowY: "scroll",
  display: "flex",
  flexDirection: "column",
  scrollSnapType: "y mandatory",
  scrollBehavior: "smooth",
  WebkitOverflowScrolling: "touch",
  overscrollBehaviorY: "contain",
  scrollbarWidth: "none",
  touchAction: "pan-y",
  "::-webkit-scrollbar": {
    width: "0px",
    height: "0px",
  },
  [theme.breakpoints.down(960)]: {
    maxWidth: "100%",
    maxHeight: "none",
    flex: 1,
    height: "100vh",
    minHeight: "100vh",
    "@supports (height: 100vh)": {
      height: "100vh",
      minHeight: "100vh",
    },
    alignSelf: "stretch",
    backgroundColor: "#000",
    overflowY: "scroll",
    overflowX: "hidden",
    WebkitOverflowScrolling: "touch",
    overscrollBehaviorY: "none",
    touchAction: "pan-y",
    scrollSnapType: "y mandatory",
    scrollBehavior: "auto",
  },

  "& .eu-home-reels-stack": {
    [theme.breakpoints.up(960)]: {
      display: "block",
    },
    [theme.breakpoints.down(960)]: {
      display: "flex",
      flexDirection: "column",
      flex: "0 0 auto",
      width: "100%",
    },
  },

  "& .imageContainer": {
    scrollSnapAlign: "start" as const,
    scrollSnapStop: "always" as const,
    height: "100%",
    minHeight: "100%",
    boxSizing: "border-box",
    position: "relative",
    width: "100%",
    background: "#000",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
    [theme.breakpoints.down(960)]: {
      flex: "0 0 auto",
      height: "100vh",
      minHeight: "100vh",
      "@supports (height: 100vh)": {
        height: "100vh",
        minHeight: "100vh",
      },
      width: "100%",
      maxWidth: "100%",
      margin: 0,
    },
    [theme.breakpoints.up(960)]: {
      width: "422px",
      margin: "0 auto",
    },
  },
  "& .profileLikeCommentContainer": {
    position: "absolute",
    right: "0px",
    top: "0",
    bottom: "0",

    display: "flex",
    flexDirection: "column",
    justifyContent: "center",  // ⭐ THIS centers everything vertically
    alignItems: "center",

    gap: "12px",
  },
  "& .postVideoImage": {
    border: "none",
    width: "100%",
    height: "100vh",
    minHeight: 0,
    outline: "none",
    background: "#000",
    "@media (max-width: 960px)": {
      height: "100vh",
      minHeight: "100vh",
      "@supports (height: 100vh)": {
        height: "100vh",
        minHeight: "100vh",
      },
    },
  },

  "& .postVideoImageCover": {
    objectFit: "cover",
    "@media (max-width: 960px)": {
      objectFit: "contain",
      backgroundColor: "#000",
    },
  },

  "& .postVideoImageContain": {
    objectFit: "cover",
  },
}));

const ParentBox = styled(Box)({
  padding: "0px 20px",
  display: "flex",
  gap: "15px",
  justifyContent: "center",
  boxSizing: "border-box",
  "@media(max-width: 960px)": {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    padding: 0,
    gap: 0,
    width: "100%",
    minHeight: 0,
    flex: 1,
    overflow: "hidden",
    "& .sideContainer": {
      "@media (max-width: 768px)": {
        display: "none",
        width: "100% !important",
      },
    },
  },
  "@media(max-width: 450px)": {
    "& .imagecontainerdiv": {
      maxWidth: "100% !important",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
    },
  },
})

const ButtonView = styled(Button)({
  backgroundColor: 'transparent !important',
  background: 'transparent !important',
  minWidth: 'unset',
  padding: 0,
  border: '1px solid #fff',
  borderRadius: '50%',
  color: '#fff',
  boxShadow: 'none !important',

  '&:hover': {
    backgroundColor: 'transparent !important',
    background: 'transparent !important',
    boxShadow: 'none',
  },

  '&:focus': {
    backgroundColor: 'transparent !important',
    background: 'transparent !important',
  },

  '&:active': {
    backgroundColor: 'transparent !important',
    background: 'transparent !important',
  },
});